import { Form, Head, usePage } from '@inertiajs/react'

type FlashProps = {
  flash?: {
    notice?: string | null
    alert?: string | null
  }
}

export default function AdminLogin() {
  const { flash } = usePage<FlashProps>().props

  return (
    <>
      <Head title="Admin sign in" />
      <div className="mx-auto flex w-full max-w-lg flex-col gap-8 px-4 py-16 sm:px-6 md:py-24">
        <div>
          <h1 className="font-headline text-2xl font-bold tracking-tight text-on-surface">Admin</h1>
          <p className="mt-2 font-body text-sm text-on-surface-variant">Sign in with your credentials.</p>
        </div>

        {flash?.alert ? (
          <p
            className="rounded-md border border-error/40 bg-error-container/15 px-4 py-3 font-mono text-sm text-error"
            role="alert"
          >
            {flash.alert}
          </p>
        ) : null}

        <Form
          action="/admin/session"
          method="post"
          className="space-y-6 border border-outline-variant/15 bg-surface-container-low p-8 rounded-lg"
        >
          <div className="space-y-2">
            <label htmlFor="admin-email" className="block font-label text-xs font-bold tracking-widest text-on-surface-variant uppercase">
              Email
            </label>
            <input
              id="admin-email"
              name="email"
              type="email"
              autoComplete="username"
              required
              className="form-well w-full px-4 py-3 font-mono text-sm"
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="admin-password" className="block font-label text-xs font-bold tracking-widest text-on-surface-variant uppercase">
              Password
            </label>
            <input
              id="admin-password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              className="form-well w-full px-4 py-3 font-mono text-sm"
            />
          </div>
          <button type="submit" className="key-btn-primary w-full">
            Sign in
          </button>
        </Form>
      </div>
    </>
  )
}
